import './App.css';
import MapComponent from './MapComponent';
import Title from './Title';

function App() {
  return (
    <div className="App">
      <Title />
      <div>
        <MapComponent />
      </div>
    </div>
  );
}

export default App;
